import React from 'react';

function CTASection({ onConsultClick }) {
  return (
    <section className="relative py-24 px-4 md:px-10 overflow-hidden">
      <div className="absolute inset-0 bg-surface-dark z-0"></div>
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 rounded-l-full blur-3xl transform translate-x-1/4"></div>
      <div className="relative z-10 max-w-[960px] mx-auto text-center flex flex-col items-center gap-8">
        <h2 className="text-3xl md:text-5xl font-black text-white leading-tight">
          지금 바로 성공의 파트너가 되세요
        </h2>
        <p className="text-gray-400 text-lg max-w-2xl">
          선착순 가맹 혜택과 함께, 당신만의 프리미엄 화환 비즈니스를 시작할 수 있는 기회를 놓치지 마세요.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <button
            onClick={onConsultClick}
            className="h-14 px-8 rounded-lg bg-primary text-[#0e1b12] text-lg font-bold hover:bg-white hover:text-primary transition-all duration-300 shadow-[0_0_20px_rgba(23,207,84,0.3)]"
          >
            무료 상담 신청하기
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-2 flex items-center gap-2">
          <span className="material-symbols-outlined text-primary text-base">check_circle</span>
          상담 신청 시 사업 제안서 무료 발송
        </p>
      </div>
    </section>
  );
}

export default CTASection;
